export const SCREEN_MAX_WIDTH = 1600;
export const DRAWER_WIDTH = 300;
export const FIVE_MINUTES = 60 * 5;
export const DECIMAL_REGEX = /^\d*,?(?:\d{1,6})?$/;
export const DECIMAL_REGEX_BETWEEN_0_AND_100 = /^((100((,)[0-9]{1,2})?)|([0-9]{1,2}((,)[0-9]{0,2})?))?$/;
